var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ns-toast',{attrs:{"icon":"","warning":_vm.warning,"success":_vm.success,"message":_vm.message,"show-trigger":_vm.trigger,"cta-button":_vm.buttonText,"on-cta-click":_vm.buttonClick}})}
var staticRenderFns = []

export { render, staticRenderFns }